"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrMaintenanceNotificationWrapper = exports.FdrMaintenanceNotification = void 0;
const react_1 = __importDefault(require("react"));
const core_basis_bs_icon_1 = require("@hotelplan/core.basis.bs-icon");
const core_fusion_bs_button_with_icon_1 = require("@hotelplan/core.fusion.bs-button-with-icon");
const fdr_maintenance_notification_styles_1 = require("./fdr-maintenance-notification.styles");
const styled_components_1 = __importDefault(require("styled-components"));
const FdrMaintenanceNotification = (_a) => {
    var { onClose, className } = _a, notification = __rest(_a, ["onClose", "className"]);
    const { id, mainTitle, mainText, closable } = notification;
    const testId = `information-notification-${id}`;
    return (react_1.default.createElement("div", { className: `maintenance-notification ${className}`, "data-id": testId },
        react_1.default.createElement(fdr_maintenance_notification_styles_1.FdrMaintenanceNotificationHeader, { className: "notification-heading" },
            mainTitle && (react_1.default.createElement("span", { className: "warning-notification-title", "data-id": `${testId}Title`, dangerouslySetInnerHTML: { __html: mainTitle } })),
            closable ? (react_1.default.createElement(core_fusion_bs_button_with_icon_1.BsButtonWithIcon, { className: "warning-notification-button", icon: { name: 'close', size: 'lg' }, onClick: onClose })) : (react_1.default.createElement(core_basis_bs_icon_1.BsIcon, { name: 'warning', className: "warning-notification-icon" }))),
        react_1.default.createElement(fdr_maintenance_notification_styles_1.FdrMaintenanceNotificationBody, { "data-id": `${testId}Text`, className: "notification-body", dangerouslySetInnerHTML: { __html: mainText } })));
};
exports.FdrMaintenanceNotification = FdrMaintenanceNotification;
exports.FdrMaintenanceNotificationWrapper = (0, styled_components_1.default)(exports.FdrMaintenanceNotification)(({ theme }) => theme.notifications.mantainanceNotification, ({ solidBg, backgroundColor }) => backgroundColor
    ? {
        border: `2px solid ${backgroundColor}`,
        '.notification-heading': { backgroundColor },
        '.notification-body': solidBg ? { backgroundColor } : null,
    }
    : null);
//# sourceMappingURL=fdr-maintenance-notification.js.map